// extracted by mini-css-extract-plugin
module.exports = {"tiny":"455px","small":"561px","mobile":"768px","tablet":"901px","desktop":"1101px","large":"1301px","wide":"1367px"};